/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { receivePurchases } from "./actions/PurchasesActions"
import PurchasesItem from "../global/components/purchasesItem/purchasesItem";
import "./index.scss";

/**
 * @desc Module "Home page".
 * @return {JSX.Element} - module that includes a default page, when user opens the web-app
 */


const PurchasesPage = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(2);
  const { posts, total } = useSelector(state => state.purchases);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(receivePurchases({ page: 1 }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getNextPage = () => {
    dispatch(receivePurchases({ page: page }));
    setPage(page + 1);
  };


  const blogRender = posts.map(item => {
    return <PurchasesItem key={Math.random()} image={item.image}
      name={item.name}
      body={item.body}
      code={item.code}
      date={item.date} />
  })

  return (<>
    <div className="blog-main">
      <div className="container">
        <div className="row">
          
            {blogRender}
         
        </div>
      </div>
      <div className="d-flex justify-content-center btn-blog">
        {posts.length < total && <button type="button" className="btn" onClick={getNextPage}>Показати ще</button>}
      </div>

    </div>
  </>)

}

export default PurchasesPage;



